import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import {
  TextValidator,
  ValidatorForm,
  SelectValidator,
} from "react-material-ui-form-validator";
import {
  contratacionesContactoStore
} from "../../../actions/contrataciones/contratacionesContactos";
import { useForm } from "../../../hooks/useForm";
import { CboLocalidades } from "../../cbos/CboLocalidades";
import { CboProvincias } from "../../cbos/CboProvincias";

export const ContactoContratacionesModal = (props) => {
  const { items } = useSelector((state) => state.localidades);
  const { contactoEditDelete } = useSelector(state => state.contratacionesContactos);

  const dispatch = useDispatch();

  let nuevoContacto = {
    idEfectorContacto: null,
    idTipoContacto: "",
    nombreApellido: "",
    email: "",
    calle: "",
    nro: "",
    piso: "",
    depto: "",
    cp: "",
    idLocalidad: "",
    idProvincia: "",
    interno: "",
    telefono: "",
    celular: "",
    cargo: "",
    observaciones: "",
  };

  const { tipoContacto } = props;

  const [
    formValues,
    handleInputChange,
    reset,
    ,
    ,
    ,
    ,
    ,
    setearVariosValores,
  ] = useForm(nuevoContacto);

  const {
    idTipoContacto,
    nombreApellido,
    email,
    calle,
    nro,
    piso,
    depto,
    cp,
    idLocalidad,
    idProvincia,
    interno,
    telefono,
    celular,
    cargo,
    observaciones,
  } = formValues;

  const handleCpChange = (e) => {
    let reg = new RegExp("^[0-9]+$");
    const cp = e.target.value;
    if ((cp === "" || reg.test(cp)) && cp?.toString().length <= 4) {
      const listaFiltrada = items.filter(loc => cp?.toString().length === 4 && parseInt(loc.codigo_postal) === parseInt(cp));
      if(listaFiltrada?.length > 0){
        const localidad = listaFiltrada[0];
        setearVariosValores({
          ...formValues,
          cp: cp,
          idLocalidad: localidad?.id_localidad,
          idProvincia: localidad?.id_provincia
        });
      }else{
        setearVariosValores({
          ...formValues,
          cp: cp,
          idLocalidad: "",
          idProvincia: ""
        });
      }
    }
  }

  const handleLocalidadChange = (e) => {
    if (items?.length > 0) {
      const localidad = items.find(
        (loc) => parseInt(loc?.id_localidad) === parseInt(e.target.value)
      );
      setearVariosValores({
        idLocalidad: localidad?.id_localidad,
        idProvincia: localidad?.id_provincia,
      });
    }
  };

  const handleSaveContacto = (e) => {
    e.preventDefault();
    dispatch(contratacionesContactoStore(formValues));
  };

  useEffect(() => {
    if (contactoEditDelete !== null) {
      setearVariosValores({
        idEfectorContacto: contactoEditDelete.id,
        idTipoContacto: contactoEditDelete.id_tipo_contacto,
        nombreApellido: contactoEditDelete.nombreApellido,
        cargo: contactoEditDelete.cargo,
        email: contactoEditDelete.email,
        interno: contactoEditDelete.interno,
        telefono: contactoEditDelete.telefono,
        celular: contactoEditDelete.telCelular,
        calle: contactoEditDelete.calle,
        nro: contactoEditDelete.nro,
        piso: contactoEditDelete.piso,
        depto: contactoEditDelete.depto,
        cp: contactoEditDelete.cp,
        idLocalidad: contactoEditDelete.id_localidad,
        idProvincia: contactoEditDelete.id_provincia,
        observaciones: contactoEditDelete.observaciones,
      });
    } else {
      setearVariosValores(nuevoContacto);
    }
    // eslint-disable-next-line
  }, [contactoEditDelete]);

  useEffect(() => {
    if (props.open === false) {
      reset();
    }
    // eslint-disable-next-line
  }, [props.open]);

  const validadoresTelefono =
    celular?.length === 10 || email?.length > 0
      ? ["isNumber", "maxNumber:9999999999", "minNumber:999999999"]
      : ["required", "isNumber", "maxNumber:9999999999", "minNumber:999999999"];

  const errorMessageTelefono =
    celular?.length === 10 || email?.length > 0 
      ? ["Solo numeros", "Verifique su telefono", "Verifique su telefono"]
      : [
          "El telefono es requerido",
          "Solo numeros",
          "Verifique su telefono",
          "Verifique su telefono",
        ];

  const validadoresCelular =
    telefono?.length === 10 || email?.length > 0 
      ? ["isNumber", "maxNumber:9999999999", "minNumber:999999999"]
      : ["required", "isNumber", "maxNumber:9999999999", "minNumber:999999999"];

  const errorMessageCelular =
    telefono?.length === 10 || email?.length > 0
      ? ["Solo numeros", "Verifique su celular", "Verifique su celular"]
      : ["El celular es requerido", "Solo numeros", "Verifique su celular", "Verifique su celular"];


  const validadoresEmail =
    telefono?.length === 10 || celular?.length === 10
      ? ["isEmail"]
      : ["required", "isEmail"];

  const errorMessageEmail =
      telefono?.length === 10 || celular?.length === 10
        ? ["Email invalido"]
        : ["El Email es requerido", "Email invalido"];

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={props.open}
        onClose={() => {
          props.handleClose()
        }}

        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Nuevo Contacto</DialogTitle>
        <DialogContent>
          <ValidatorForm onSubmit={handleSaveContacto}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <SelectValidator
                  fullWidth
                  margin="normal"
                  label="Tipo de Contacto"
                  name="idTipoContacto"
                  value={idTipoContacto}
                  onChange={handleInputChange}
                >
                  {tipoContacto.map(({ idTipoContacto, descripcion }) => (
                    <MenuItem key={idTipoContacto} value={idTipoContacto}>
                      {descripcion}
                    </MenuItem>
                  ))}
                </SelectValidator>
              </Grid>
              <Grid item xs={12}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  label="Nombre y Apellido"
                  name="nombreApellido"
                  value={nombreApellido}
                  onChange={handleInputChange}
                  validators={["required"]}
                  errorMessages={["El nombre es requerido"]}
                />
              </Grid>
              <Grid item xs={6}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  label="Email"
                  name="email"
                  value={email}
                  onChange={handleInputChange}
                  validators={validadoresEmail}
                  errorMessages={errorMessageEmail}
                  //validators={["required", "isEmail"]}
                  //errorMessages={["El EMail es requerido", "Email invalido"]}
                />
              </Grid>
              <Grid item xs={6}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  label="Cargo"
                  name="cargo"
                  value={cargo}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  label="Calle"
                  name="calle"
                  value={calle}
                  onChange={handleInputChange}
                  validators={["required"]}
                  errorMessages={["La calle es requerida"]}
                />
              </Grid>
              <Grid item xs={2}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  label="Nro"
                  name="nro"
                  value={nro}
                  onChange={handleInputChange}
                  validators={["required"]}
                  errorMessages={["El nro es requerido"]}
                />
              </Grid>
              <Grid item xs={1}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  label="Piso"
                  name="piso"
                  value={piso || ""}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={1}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  label="Depto"
                  name="depto"
                  value={depto || ""}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={2}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  label="CP"
                  name="cp"
                  value={cp || ""}
                  onChange={handleCpChange}
                  maxLength="4"
                  validators={[
                    "required",
                    "isNumber",
                    "maxNumber:9999",
                    "minNumber:999",
                  ]}
                  errorMessages={[
                    "CP requerido",
                    "Sólo números",
                    "Verifique Cod.Postal",
                    "Verifique Cod.Postal",
                  ]}
                />
              </Grid>
              <Grid item xs={6}>
                <CboLocalidades
                  name="idLocalidad"
                  cp={cp ? cp : 0}
                  valor={idLocalidad}
                  manejadorInputChange={handleLocalidadChange}
                />
              </Grid>
              <Grid item xs={6}>
                <CboProvincias
                  name="idProvincia"
                  valor={idProvincia}
                  manejadorInputChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={1}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  label="Int"
                  name="interno"
                  value={interno}
                  onChange={handleInputChange}
                  validators={[
                    "isNumber",
                    "maxNumber:9999",
                    "minNumber:1"
                  ]
                  }
                  errorMessages={[
                    "Sólo números",
                    "Verifique el interno",
                    "Verifique el interno",
                  ]}
                />
              </Grid>
              <Grid item xs={5}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  label="Tel. Particular(10 dígitos sin el 0)"
                  name="telefono"
                  value={telefono}
                  onChange={handleInputChange}
                  validators={validadoresTelefono}
                  errorMessages={errorMessageTelefono}
                />
              </Grid>
              <Grid item xs={6}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  label="Tel. Celular(10 dígitos sin 0 ni 15)"
                  name="celular"
                  value={celular}
                  onChange={handleInputChange}
                  maxLength="10"
                  validators={validadoresCelular}
                  errorMessages={errorMessageCelular}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="button" display="block" gutterBottom>
                  Observaciones
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  rowsMax={8}
                  variant="outlined"
                  name="observaciones"
                  value={observaciones}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>
            <div style={{ textAlign: "right", marginTop: "0.5rem" }}>
              <Button type="submit" color="primary">
                Aceptar
              </Button>
              <Button onClick={props.handleClose} type="button" color="primary">
                Cancelar
              </Button>
            </div>
          </ValidatorForm>
        </DialogContent>
      </Dialog>
    </div>
  );
};